import regExp from '@shared/utils/helpers/regular-expressions'

export const generatePhoneLink = (message: string) => {
  const replacedText = message.replace(regExp.usNumberRegExp, (match) => {
    return `<a href="tel:${match}">${match}</a>`
  })

  return replacedText
}
